<div class="white-bg no-padding no-margin">

  <mat-card > 
    <div style="text-align: center; margin-top: 1%;">
      <span class="title-header">Training </span>
    </div>
    <div style="margin-top: 1%;">
      <span class="title-sub-header" style="font-size: 18px;">{{sectionName}} </span>
    </div>
    

    <ng-container *ngIf="isSectionQView==false" >
      <div *ngIf="isURL==false" style="text-align: center; margin-top: 1%;">
        <img style="width:50%" *ngIf="isURL==false" [src]="sanitize(selectedSlide)">
      </div>
  
      <div *ngIf="isURL==true" style="text-align: center; margin-top: 1%;">
        <iframe width="420" height="530" [src]="LoadURL(selectedSlide)" style="width: 100%; "></iframe>
  
      </div>
    </ng-container>
<div [hidden]="!showslide">
  <ng-container >
    <div *ngIf="isURL_==false" style="text-align: center; margin-top: 1%;">
      <img style="width:50%" *ngIf="isURL_==false" [src]="sanitize(selectedSlide_)">
    </div>

    <div *ngIf="isURL_==true" style="text-align: center; margin-top: 1%;">
      <iframe width="420" height="530" [src]="LoadURL(selectedSlide_)" style="width: 100%; "></iframe>

    </div>

    <div  style="width: 100%;   display: flex;flex-direction: row;justify-content:flex-end;">
      <a class="button button--primary" (click)="GotPreviousQuestions()">
        <span class="button__text">Section Questions</span></a>
    </div>
  </ng-container>
</div>
    

<div [hidden]="!show">
  <ng-container *ngIf="isSectionQView==true" style="margin-top: 1%;">
    <ng-container *ngFor="let q of TrainingQuestions" >

      
      <div style="margin-top: 1%;    display: flex;">
        <a>

          <i *ngIf="q.Invalid==true" class="material-icons button__icon"
            style="font-size: 28px;margin-right: 20px; color:red;vertical-align: middle; cursor: pointer;" (click)="GotoReleventSlide(q.SlideId)"
            >report_problem</i>
        </a>
        <span class="title-sub-header" >{{q.Order+1}}.) {{q.QuestionName}} </span>
      </div>

        <ng-container *ngIf="q.QuestionTypeId==2 ||  q.QuestionTypeId==1"> 
          <div class="input-container flexInput" style="margin-top: 4px; margin-left: 5%;" >
            <mat-radio-group aria-label="Select Slide Type"   id="ans_{{q.QuestionId}}" style="    display: flex; flex-direction: column;">
              <mat-radio-button *ngFor="let option of q.AnswerList" [value]="option.Id" (click)="SelectAnswerRadio(option,q)">
                {{option.Name}}
                <span><i *ngIf="option.Select==true && q.Invalid==true" class="material-icons button__icon"
                  style="font-size: 25px;margin-right: 20px; color:#1db330de;vertical-align: middle; cursor: pointer;" >verified</i></span>
              </mat-radio-button>
            </mat-radio-group>
          </div>
        </ng-container>

        <ng-container *ngIf="q.QuestionTypeId==3"> 

          <div class="input-container flexInput" style="margin-top: 4px; margin-left: 5%;" >
            <mat-list-item *ngFor="let item of q.AnswerList" id="ans_{{q.QuestionId}}">
              <mat-checkbox (change)="SelectAnswerMutipleSelection(q,item)" [value]="item.Id">
                {{ item.Name }}
                <span><i *ngIf="item.Select==true && q.Invalid==true" class="material-icons button__icon"
                  style="font-size: 25px;margin-right: 20px; color:#1db330de;vertical-align: middle; cursor: pointer;" >verified</i></span>
              </mat-checkbox>
            </mat-list-item>
          </div>
          
        </ng-container>
    </ng-container>
    <div  *ngIf="gotoNextSection==false" style="width: 100%;   display: flex;flex-direction: row;justify-content:center;">
      <a class="button button--primary" (click)="SubmitAnswers()">
        <span class="button__text">Submit</span></a>
    </div>

    <!-- <div *ngIf="gotoNextSection==true" style="width: 100%;   display: flex;flex-direction: row;justify-content:flex-end;">
      <a class="button button--primary" (click)="GotoNextSection()">
        <span class="button__text">Next Section</span></a>
    </div> -->

    <div *ngIf="FinishTrainig==true" style="width: 100%;   display: flex;flex-direction: row;justify-content:flex-end;">
      <a class="button button--primary" (click)="FinishTraing()">
        <span class="button__text">Done</span></a>
    </div>

    <div *ngIf="hasInvalidQ==true" style="background-color: lightgrey;" >
      <label style="font-size: x-large; text-align: center">You did not get all questions correct. Please use the 
      <span style="min-width:150px;color: red; max-width: 10em; text-overflow: ellipsis; overflow: hidden; white-space: nowrap;">
          <i class="material-icons button__icon">report_problem</i></span> to review the relevent slide then return to these questions to amend your answer.
      </label>
  </div>
  </ng-container>
</div>
    


    <div style="display: flex;" *ngIf="isSectionQView==false">
      <div *ngIf="isSQuestion==true" style="width: 100%;   display: flex;flex-direction: row;justify-content:center;">
        <a class="button button--primary" (click)="SectionQuestions()">
          <span class="button__text">Section Questions</span></a>
      </div>
      <div style="display: flex;" > 
        <div *ngIf="isPrevious==true" style="width: 100%;   display: flex;flex-direction: row;justify-content:center;">
          <a class="button button--primary" (click)="PreviousSlide()">
            <span class="button__text ">Previous</span></a>
        </div>
  
        <div *ngIf="isNext==true" style="width: 100%;   display: flex;flex-direction: row;justify-content:center; margin-left: 1%;">
          <a class="button button--primary" (click)="NextSlide()">
            <span class="button__text ">Next</span></a>
        </div>

        
      </div>
    
    </div>



  

  </mat-card>

  <div class="w3-light-grey">
    <div class="w3-container w3-green w3-center" [ngStyle]="{'width':selectedwith}">{{selectedwith}}</div>
  </div><br>
    
  
</div>